import React, { useState, useEffect } from "react";
import Sidebar from "../sidebar/Sidebar";
import HeaderAll from "../../HeaderAll";

const AdminLayout = ({ children, sidebarComponent: SidebarComponent = Sidebar }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="h-screen overflow-hidden flex bg-[#e9efff]">
      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={closeSidebar}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed lg:static top-0 left-0 h-full z-50 transition-all duration-300 transform 
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} 
        lg:translate-x-0 
        ${isCollapsed ? "lg:w-20" : "lg:w-64"} w-64 lg:w-auto`}
      >
        <SidebarComponent
          isCollapsed={isCollapsed}
          onToggleCollapse={handleToggleCollapse}
          closeSidebar={closeSidebar}
          isMobileOpen={sidebarOpen}
        />
      </div>

      {/* Main Area */}
      <div className="flex-1 flex flex-col overflow-hidden w-full">
        {/* Top Header */}
        <div className="bg-white border-b border-[#9FACF0]">
          <HeaderAll onMenuClick={toggleSidebar} />
        </div>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-white p-3 md:p-5 lg:p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
